import {Component, inject} from '@angular/core';
import {EventsManager} from '../../events/events.manager';
import {DataService} from 'src/app/services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})

export class HeaderComponent {
  public eventsManager: EventsManager = inject(EventsManager);
  public dataService: DataService = inject(DataService);
}
